module.exports = __webpack_public_path__ + "static/media/alert.f875b635.png";